<template>
<div>
    <div class="table-container">
        <!-- table -->
        <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
              enabled: true,
              externalQuery: searchTerm
            }" :pagination-options="{
              enabled: false,
              perPage: pageLength
            }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'lawPaymentId'" class="text-nowrap">
                    {{ $t('lawPaymentDetail.select_invoice') }}
                </span>
            </template>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'lawPaymentId'">
                    <b-form-checkbox :checked="checkStatus(props.row.lawPaymentId)" @change.native="save($event.target.checked, props.row)" />
                </span>
            </template>
        </vue-good-table>
    </div>
</div>
</template>

<script>
export default {
    props: {
        getPaymentList: Function
    },
    data() {
        return {
            id: 0,
            pageLength: 10,
            dir: false,
            selected: null,
            columns: [{
                    label: this.$t('lawPaymentDetail.payment_id'),
                    field: `lawPaymentId`,
                },
                {
                    label: this.$t('lawPaymentDetail.invoice_no'),
                    field: `lawInvoiceNo`,
                },
                {
                    label: this.$t('lawPaymentDetail.invoice_date'),
                    field: `invoiceDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('lawPaymentDetail.law_matter_record_no'),
                    field: `lawMatterRecordNo`

                },
                {
                    label: this.$t('lawPaymentDetail.total'),
                    field: `total`,
                },
                {
                    label: this.$t('lawPaymentDetail.employee'),
                    field: `employee`,
                },
            ],
            rows: [],
            searchTerm: '',
            lawPaymentId: 0,
            selectControl: false,
            invoiceTotal: 0,
        }
    },
    methods: {
        checkStatus(lawPaymentId) {
            if (lawPaymentId == 0)
                return false
            else
                return true;
        },
        getPaymentDetailList(lawPaymentId, clientAccountingId) {
            if (lawPaymentId == 0 && clientAccountingId == 0)
                return;
            this.lawPaymentId = lawPaymentId
            this.rows = []
            const data = {
                lawPaymentId: this.lawPaymentId,
                clientAccountingId: clientAccountingId
            }
            const controller = {
                name: 'LawInvoice',
                actionName: 'GetLawInvoiceListForPayment'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.lawInvoiceListForPayment
                    if(response.data.lawInvoiceListForPayment.length && response.data.lawInvoiceListForPayment.filter(x => x.lawPaymentId > 0).length){
                         this.invoiceTotal = parseFloat(response.data.lawInvoiceListForPayment.filter(x => x.lawPaymentId > 0).reduce((n, {
                        total
                    }) => n + total, 0)).toFixed(2)
                     this.$emit('invoiceTotalChanged', this.invoiceTotal);
                    }
                   
                }
            })
        },
        save(selected, params) {
            const controller = {
                name: 'LawInvoice',
                actionName: 'SaveLawInvoiceForPayment'
            }
            if (selected) {
                const data = {
                    id: params.lawInvoiceId,
                    lawPaymentId: this.lawPaymentId,
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$SaveAlert()
                        this.invoiceTotal = parseFloat(this.invoiceTotal) + parseFloat(params.total)
                        this.$emit('invoiceTotalChanged', this.invoiceTotal);
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            } else {
                const data = {
                    id: params.lawInvoiceId,
                    lawPaymentId: 0
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$SaveAlert()
                        this.invoiceTotal = parseFloat(this.invoiceTotal) - parseFloat(params.total)
                        this.$emit('invoiceTotalChanged', this.invoiceTotal);
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            }
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.table-container {
    max-height: 400px;
    /* Tablonun maksimum yüksekliği, gereksinimlerinize göre ayarlayın */
    overflow-y: auto;
    /* Dikey kaydırma çubuğunu etkinleştir */
}

.vgt-table thead th.vgt-checkbox-col {
    vertical-align: middle;
    visibility: hidden;
}
</style>
